import type { SVGProps } from 'react';

const paths = {
  atrium: <><path d="m12 2 8.5 5v10L12 22l-8.5-5V7Z"/><path d="m12 6 5 3v6l-5 3-5-3V9Z M12 6v12 M7 9l10 6 M17 9l-10 6"/></>,
  arrow: <path d="M4 12h15m-6-6 6 6-6 6"/>,
  plus: <path d="M12 4v16M4 12h16"/>,
  people: <><circle cx="9" cy="8" r="3"/><path d="M3 20v-3a6 6 0 0 1 12 0v3M17 5a3 3 0 0 1 0 6m1 3a5 5 0 0 1 3 5"/></>,
  focus: <><path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/><circle cx="12" cy="12" r="3"/></>,
  check: <path d="m5 12 4 4L19 6"/>,
  link: <path d="m10 14 4-4m-7 1-2 2a4 4 0 0 0 6 6l2-2m-2-10 2-2a4 4 0 0 1 6 6l-2 2"/>,
  close: <path d="m6 6 12 12M6 18 18 6"/>,
  search: <><circle cx="10" cy="10" r="6"/><path d="m15 15 6 6"/></>,
  copy: <><rect x="8" y="8" width="12" height="13" rx="1"/><path d="M16 8V3H3v13h5"/></>,
  expand: <path d="M9 3H3v6m12-6h6v6M3 15v6h6m12-6v6h-6"/>,
  collapse: <path d="M5 12h14"/>,
  settings: <><path d="M4 6h16M4 12h16M4 18h16"/><circle cx="8" cy="6" r="2"/><circle cx="16" cy="12" r="2"/><circle cx="10" cy="18" r="2"/></>,
  width: <path d="M3 5v14M21 5v14M7 12h10m-7-3-3 3 3 3m4-6 3 3-3 3"/>,
  tasks: <><path d="m3 6 1.5 1.5L7 5m3 1h11M3 12h3m4 0h11M3 18h3m4 0h11"/></>,
  chat: <path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 3V6a2 2 0 0 1 2-2Z M7 9h10M7 13h6"/>,
  lock: <><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3"/></>,
  tools: <path d="M14 4a6 6 0 0 0-7 8L3 16a3 3 0 0 0 4 4l5-5a6 6 0 0 0 8-7l-4 4-4-4 4-4Z"/>,
  agent: <><rect x="4" y="7" width="16" height="13" rx="3"/><path d="M12 3v4M2 12v4m20-4v4M9 16h6M8 11v2m8-2v2"/></>,
  activity: <path d="M2 12h5l3-8 4 16 3-8h5"/>,
  help: <><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 4 2c-1 .7-1.5 1.3-1.5 2.5M12 17h.01"/></>,
  pause: <><path d="M8 5v14M16 5v14"/></>,
  play: <path d="m8 4 12 8-12 8Z"/>,
  chevron: <path d="m6 9 6 6 6-6"/>,
  target: <><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/></>,
  upload: <path d="M12 16V3m-5 5 5-5 5 5M4 15v5h16v-5"/>,
  pin: <path d="m9 3 12 12-3 1-4-4-5 5-3 1 1-3 5-5-4-4 1-3ZM6 18l-3 3"/>,
  return: <path d="m8 5-5 5 5 5M3 10h12a5 5 0 0 1 0 10h-3"/>,
  back: <path d="M20 12H5m6-6-6 6 6 6"/>,
  spark: <><path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z M20 3v4m-2-2h4"/></>,
};

export type RoomIconName = keyof typeof paths;
export type RoomIconProps = SVGProps<SVGSVGElement> & { name: RoomIconName; size?: number };

/** Decorative by default: the containing control supplies the action's accessible name. */
export function RoomIcon({ name, size = 24, ...props }: RoomIconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>{paths[name]}</svg>;
}

export default RoomIcon;
